import { z } from 'zod'
import { optionalText, requiredId, requiredNumber, requiredText } from '../../../lib/forms/rules'

/** Etkinlik türü "Diğer" sentinel id'si (REF_ACTIVITY_EVENT_TYPE). Seçilince tür açıklaması zorunlu. */
export const OTHER_EVENT_TYPE_ID = -1

/**
 * Yeni Etkinlik formu — 1. bölüm (Etkinlik Özeti) şeması (US2). Zorunlu alanlar DB NOT NULL + katılımcı
 * sayısı (mockup). Koşullu: tür "Diğer" → açıklama zorunlu; bitiş ≥ başlangıç. Alt bölümler (skor/paydaş/
 * birim/dosya) form dışı state'te tutulur ve gönderimde ayrıca doğrulanır (backend de doğrular).
 */
export const activityFormSchema = z
  .object({
    nameTr: requiredText(1000),
    nameEn: optionalText(1000),
    organizingInstitution: requiredText(1000),
    startDate: requiredText(),
    endDate: requiredText(),
    numberOfParticipants: requiredNumber(),
    countryId: requiredId(),
    cityId: requiredId(),
    eventTypeId: requiredId(),
    otherEventType: optionalText(1000),
    invitationTypeId: requiredId(),
    featuredParticipants: optionalText(4000),
    website: optionalText(1000),
  })
  .superRefine((v, ctx) => {
    if (v.eventTypeId === OTHER_EVENT_TYPE_ID && !(v.otherEventType && v.otherEventType.trim())) {
      ctx.addIssue({ code: 'custom', path: ['otherEventType'], message: 'validation.required' })
    }
    if (v.startDate && v.endDate && v.endDate < v.startDate) {
      ctx.addIssue({ code: 'custom', path: ['endDate'], message: 'validation.endBeforeStart' })
    }
  })

export type ActivityFormValues = z.infer<typeof activityFormSchema>
